var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        class: _vm.ondeliver ? "show" : "show",
        style: _vm.ondeliver ? "display: block; padding-left: 0px;" : "",
        attrs: { tabindex: "-1", role: "dialog" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
          [
            _c("div", { staticClass: "modal-content shadow-3" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4",
                  },
                  [_c("i", { staticClass: "bi bi-box" })]
                ),
                _vm._v(" "),
                _vm.data != {}
                  ? _c("div", [
                      _c("h5", { staticClass: "mb-1" }, [
                        _vm._v(_vm._s(_vm.data.type) + _vm._s(_vm.data.id)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "small",
                        { staticClass: "d-block text-xs text-muted" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              staticClass: "mx-1",
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        Array.isArray(_vm.data.description)
                                          ? _c(
                                              "div",
                                              _vm._g(
                                                _vm._b(
                                                  { staticClass: "nowrap" },
                                                  "div",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.data.description[0]
                                                    ) +
                                                    " ...\n                                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1278189049
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "small",
                                _vm._l(
                                  _vm.data.description,
                                  function (description, key) {
                                    return _c("div", { key: key }, [
                                      _vm._v(_vm._s(description)),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "ms-auto" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "vstack gap-3" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _c("v-checkbox", {
                              attrs: {
                                color: "success",
                                label: "Pagar",
                                "hide-details": "",
                              },
                              model: {
                                value: _vm.checkbox,
                                callback: function ($$v) {
                                  _vm.checkbox = $$v
                                },
                                expression: "checkbox",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.checkbox
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "card cursor-pointer",
                              class:
                                _vm.payment_method == 0 ? "bg-soft-danger" : "",
                              on: {
                                click: function ($event) {
                                  _vm.payment_method = 0
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-block text-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "icon icon-shape rounded-3 text-dark text-lg mb-3",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "bi bi-cash-stack",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "d-block text-xs text-muted",
                                        },
                                        [_vm._v("Efectivo")]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "card cursor-pointer",
                              class:
                                _vm.payment_method == 1 ? "bg-soft-danger" : "",
                              on: {
                                click: function ($event) {
                                  _vm.payment_method = 1
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-block text-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "icon icon-shape rounded-3 text-dark text-lg mb-3",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "bi bi-credit-card-fill",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "d-block text-xs text-muted",
                                        },
                                        [_vm._v("Tarjeta")]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "card cursor-pointer",
                              class:
                                _vm.payment_method == 2 ? "bg-soft-danger" : "",
                              on: {
                                click: function ($event) {
                                  _vm.payment_method = 2
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-block text-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "icon icon-shape rounded-3 text-dark text-lg mb-3",
                                      },
                                      [_c("i", { staticClass: "bi bi-bank" })]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "d-block text-xs text-muted",
                                        },
                                        [_vm._v("Transferencia")]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "card cursor-pointer",
                              class:
                                _vm.payment_method == 3 ? "bg-soft-danger" : "",
                              on: {
                                click: function () {
                                  _vm.payment_method = 3
                                  _vm.currency = "₡"
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-block text-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "icon icon-shape rounded-3 text-dark text-lg mb-3",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "bi bi-phone-fill",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "d-block text-xs text-muted",
                                        },
                                        [_vm._v("Sinpe movil")]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 mb-3" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "card cursor-pointer",
                              class:
                                _vm.currency == "$"
                                  ? "bg-soft-danger"
                                  : _vm.payment_method == 3
                                  ? "bg-light"
                                  : "",
                              on: {
                                click: function ($event) {
                                  _vm.payment_method != 3
                                    ? (_vm.currency = "$")
                                    : (_vm.currency = _vm.currency)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-block text-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "icon icon-shape rounded-3 text-dark text-lg",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                $\n                                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "card cursor-pointer",
                              class:
                                _vm.currency == "₡" ? "bg-soft-danger" : "",
                              on: {
                                click: function ($event) {
                                  _vm.currency = "₡"
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-block text-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "icon icon-shape rounded-3 text-dark text-lg",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                ₡\n                                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 mb-3" }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-body d-flex justify-content-between align-items-center",
                          },
                          [
                            _c("h3", { staticClass: "text-lg" }, [
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  _vm._s(_vm.checkbox ? "Total" : "Pendiente") +
                                    ": "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.currency == "$"
                                ? _c(
                                    "span",
                                    { staticClass: "font-weight-medium" },
                                    [
                                      _vm._v(
                                        " $" +
                                          _vm._s(
                                            Number(
                                              _vm.data.invoice.total || 0
                                            ).toFixed(2)
                                          )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "font-weight-medium" },
                                    [
                                      _vm._v(
                                        " ₡" +
                                          _vm._s(
                                            Number(
                                              _vm.data.invoice.total *
                                                _vm.exchange_rate || 0
                                            ).toFixed(2)
                                          )
                                      ),
                                    ]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success px-3",
                                on: {
                                  click: function ($event) {
                                    return _vm.CONFIRM()
                                  },
                                },
                              },
                              [
                                _vm.count == 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "spinner-border spinner-border-sm",
                                        attrs: { role: "status" },
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Loading..."),
                                        ]),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(
                                            _vm.checkbox
                                              ? "Entregar / Pago completo"
                                              : "Entregar"
                                          ) +
                                          "\n                                            "
                                      ),
                                    ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-dark px-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onclose")
                      },
                    },
                  },
                  [_vm._v("Cerrar")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }